// Vendor Billing v1.0 — shared VFI invoice formatting + status-token
// mapping. Same condition, same color everywhere: overdue = error,
// processing = info, paid = success, issued/viewed = neutral, void = muted.
// Money reuses the servicing ledger's $-2dp/parenthesized-negatives rule.

import type { StatusTone } from "@/design-system/components/ui";
import type { VendorInvoiceStatus } from "@/api/portfolioAdmin/types";

export { fmtMoney } from "@/components/portfolioAdmin/loanDetail/paymentTracking/servicingFormat";

export const INVOICE_STATUS_LABEL: Record<VendorInvoiceStatus, string> = {
  draft: "Draft",
  issued: "Issued",
  viewed: "Viewed",
  processing: "Processing",
  paid: "Paid",
  overdue: "Overdue",
  void: "Void",
};

export function invoiceStatusTone(status: VendorInvoiceStatus): StatusTone {
  switch (status) {
    case "paid":
      return "ok";
    case "overdue":
      return "danger";
    case "processing":
      return "info";
    case "void":
      return "muted";
    default:
      return "neutral";
  }
}

/** Statuses a Void action is legal from (mirrors the server machine). */
export const VOIDABLE_STATUSES: readonly VendorInvoiceStatus[] = [
  "draft",
  "issued",
  "viewed",
  "overdue",
];

/** Statuses a manual payment is legal from (mirrors the server machine). */
export const MANUAL_PAYABLE_STATUSES: readonly VendorInvoiceStatus[] = [
  "issued",
  "viewed",
  "overdue",
];
